import { render, staticRenderFns } from "./washlist.vue?vue&type=template&id=052672b1&"
import script from "./washlist.vue?vue&type=script&lang=js&"
export * from "./washlist.vue?vue&type=script&lang=js&"
import style0 from "./washlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports